import React, { Component } from "react";
import Table from "../../../components/table/Table";
import { Navigate } from "react-router-dom";
import moment from "moment";
import ActionContainer from "../../../components/UIComponent/ActionTableComponent/actionContainer";
import DropdownAction from "../../../components/dropdown/DropdownAction";
import MembershipTaskListServices from "../../../services/axiosServices/apiServices/MembershipTaskListServices";
import DropdownSelect from "../../../components/dropdown/Dropdown";
import SlotProbationTaskListProcess from "./SlotProbationTaskListProcess";
import { saveAs } from "file-saver";
import {
    CommonValidationMessages,
} from "../../../utils/Messages";
import {
    isValidForm,
    validate,
} from "../../../utils/validation/CommonValidator";
import SendForApprove from "./SendApproveModal";
import SendClarifications from "./SendClarifications";
import SendPaymentLink from "./SendPaymentLink";
import SendQuotation from "./SendQuotation";
import SendInvoice from "./SendInvoice";
import EscalateModal from "./EscalateModal";
import { CommonSuccessMessages } from "../../../utils/Messages";
import SwalServices from "../../../services/swalServices/SwalServices";

import { getAuthProps } from "../../../utils/AuthenticationLibrary";
import SlotMemberService from "../../../services/axiosServices/apiServices/SlotMemberService";



export default class SLOTsProbationTaskList extends Component {
    constructor(props) {
        super(props);
        this.TaskListServices = new MembershipTaskListServices();
        this.swalServices = new SwalServices();
        this.slotMemberService = new SlotMemberService();

        this.state = {
            sendApprovalReason: '',
            pagination: {
                pageNo: 1,
                pageSize: 10,
                orderByColumn: "",
                orderFlag: 0,
                dateFrom: null,
                dateTo: null,
                FilterByStatus: '',
                IsApprovalRequired: 0,
            },

            statuses: [],
            IsCompleted: false,
            IsOngoing: false,
            updatedBy: 0,
            updatedAppId: 0,
            adminName: '',
            totalResultes: "",
            taskList: [],
            isLoading: false,
            isLoadingPayment: false,
            isLoadingQuotation: false,
            isLoadingInvoice: false,
            isLoadingApprove: false,
            isEscalateLodaing: false,
            route: null,
            redirect: null,
            membershipTypes: [],
            transactionTypes: [],
            billingCategories: [],
            membershipRevenueList: [],
            selectedTaskId: 0,
            sourceList: [
                {
                    id: 1,
                    name: "Admin"
                },
                {
                    id: 2,
                    name: "Web"
                },
            ],
            users: [],
            tenureList: [],
            designationList: [],
            // numberOfChapters: [
            //   { id: 0, name: "0" },
            //   { id: 1, name: "1" },
            //   { id: 2, name: "2" },
            //   { id: 3, name: "3" },
            //   { id: 4, name: "4" },
            //   { id: 5, name: "5" },
            // ],
            numberOfChapters: [
                { id: 1, name: "0" },
                { id: 2, name: "1" },
                { id: 3, name: "2" },
                { id: 4, name: "3" },
                { id: 5, name: "4" },
                { id: 6, name: "5" },
            ],
            internalComments: {
                internalComment: "",
                isApprovedProbation: 0
            },
            taskDetails: {
                taskId: 0,
                slotsMemberId: 0,
                rejectSlotProbationReson: '',

                companyName: "",
                chineseCompanyName: "",
                uenNumber: "",
                incorporationDate: "",
                firstName: "",
                lastName: "",
                businessEmail: "",
                statusName: "",
                billingCategoryId: 1,
                updatedBy: 0,
                subscriptionStartDate: "",
                subcriptionEndDate: "",
                membershipTypeId: 1,
                transactionTypeId: 1,
                startMembershipOn: "",
                isStartMembership: false,
                isAppliedForRenewal: false,
                startMembership: false,
                ordinaryApplicationFee: "",
                annualOrdinaryRevenueFee: "",
                selectedMembershipType: "",
                applicationFee: 0,
                annualRevenueFee: 0,
                mrMrsId: 0,
                businessEmail: "",
                isApplicationFee: false,
                statusId: 0,
            },
            projectTypeId: 0,
            setRejectionReason: false,
            setApproveReason: false,
            sendRejectionReason: '',
            corporatePricingDetails: {},
            setDropdownOpen: false,
            membershipTaskListProcessModal: false,
            setAddeditModalOpen: false,
            ongoingProjectTrackRecordsDetailsList: [],

            completedProjectTrackRecordsDetailsList: [],
            addEditModalOpen: false,
            setSendClarifications: false,
            setPaymentLink: false,
            sendQuotation: false,
            sendInvoice: false,
            sendEscalation: false,
            basePriceTable: [],
            allowableDiscountTable: [],
            percentageDiscountTable: [],
            systemCalculatedTable: [],
            disablePaymentButton: true,
            disableSubscription: true,

            countryList: [],
            companyMainActivityList: [],
            typesOfProject: [],
            publicprojectsForm: [],
            fullStaffEmployeeLocal: [],
            fullStaffEmployeeForeginer: [],
            hearAboutUsList: [],
            annualTurnoverList: [],
            status: [],
            projectTypelist: [],

            validState: {
                isValid: true,
                error: {},
            },
            validStateForInvoice: {
                isValid: true,
                error: {},
            },
            clarification: '',
            // validStateMemberSub: {
            //     isValid: true,
            //     error: {}
            // },
            // validStatePricingTable: {
            //     isValid: true,
            //     error: {}
            // },
            // validStateInvGen: {
            //     isValid: true,
            //     error: {}
            // },
            // validationRuleMemberSub: {
            //     isValid: true,
            //     error: {}
            // },
            // validationRulePricingTable: {
            //     isValid: true,
            //     error: {}
            // },
            // validationRuleInvGen: {
            //     isValid: true,
            //     error: {}
            // },
            actionDropdown: ["Process"],

            companyActivity: [],
            publicProjectsForms: [],
            mrMrs: [],
            countriesWithPresence: [],
            organizationRoleArray: [],
            getToKnowUsArr: [],
            mainGroupList: [],
            typeOfProjects: [],
            fulltimeEmployeeLocal: [],
            fullTimeEmployeeForeigners: [],
            knowAboutusList: [],
            annualTurnover: [],
            engagementType: [],
            reasonOfLeaving: [],
            companyRegisteredWithBCAList: [],

        };

    }

    GetAllProjectTrackRecordsById = () => {
        const slotsMemberId = this.state.taskDetails.slotsMemberId;

        this.slotMemberService.GetAllProjectTrackRecordsById(slotsMemberId)
            .then((response) => {
                if (response.statusCode === 200 && response.responseItem != null) {
                    const listData = response.responseItem.responseContent;

                    const completedProjectData = listData.filter(proj => proj.isCompleted === true);
                    const ongoingProjectData = listData.filter(proj => proj.isOngoing === true);

                    this.setState({
                        projectTrackRecordsDetailsList: listData,
                        completedProjectTrackRecordsDetailsList: completedProjectData,
                        ongoingProjectTrackRecordsDetailsList: ongoingProjectData
                    });
                } else {
                    this.swalServices.Error(response.message);
                }
            });
    };
    handleChangeInPopup(event) {
        const value = event.target.value.toUpperCase();
        const name = event.target.name;
        let detail = this.state.taskDetails;
        detail[name] = value;
        this.setState({ taskDetails: { ...detail } });
    }

    handleChangeForComment(event) {
        const value = event.target.value.toUpperCase();
        const name = event.target.name;

        let detail = this.state.internalComments;
        detail[name] = value;

        this.setState({ internalComments: { ...detail } });
    }







    getAllSlotProbationTasksList = (pagination = this.state.pagination) => {
        this.setState({ isLoading: true });
        this.TaskListServices.getAllSlotProbationTasksList(pagination).then((response) => {

            if (response.statusCode === 200 && response.responseItem != null) {

                let details = response.responseItem.responseContent.itemList;
                details.map((key) => {
                    key.registrationDate = moment(key.registrationDate).format(
                        "DD MMM YYYY"
                    );


                    return details;
                });
                this.setState({ taskList: details });
                this.setState({
                    totalResultes: response.responseItem.responseContent.totalCount,
                });
            } else {
                this.swalServices.Error(response.message);
            }
            this.setState({ isLoading: false });
        });
    };

    componentDidMount() {
        let cookie = getAuthProps();
        if (cookie != null) {
            const adminUserId = cookie.adminUserId;
            const adminname = cookie.name;
            this.setState({ updatedBy: adminUserId, updatedAppId: 111, adminName: adminname });
        }
        this.getAllSlotProbationTasksList();
        this.getAllDropdownsForTaskList();
        // this.GetAllProjectTrackRecordsById();
        // this.getAllDropdownForCorporateMember();
    }
    getSlotProbationTaskById = (Id) => {
        this.TaskListServices.getSlotProbationTaskById(Id).then((response) => {
            if (response.statusCode === 200 && response.responseItem != null) {
                this.setState(
                    { taskDetails: response.responseItem.responseContent },
                    () => {
                        let data = { ...this.state.taskDetails };
                        this.setState({ taskDetails: data });
                        // Call the project track records API after taskDetails set
                        this.GetAllProjectTrackRecordsById();
                    }
                );
                this.setState({ setAddeditModalOpen: true });
            } else {
                this.swalServices.Error(response.message);
            }
            this.setState({ isLoading: false });
        });
    };




    selectTask = (value, e) => {
        e.stopPropagation();
        if (value > 0) {
            this.getSlotProbationTaskById(value);
        }
    };


    setPagination = (newPagination) => {
        this.setState({ pagination: newPagination });
        this.getAllSlotProbationTasksList(newPagination);
    };
    actionClick = (index, value, option, event) => {
        var id = this.state.taskList[index].slotsMemberId;
        this.setState({ selectedTaskId: this.state.taskList[index].taskId }, () => {
            this.selectTask(id, event);
        });
    };


    actions = (element, index, value) => {
        return element !== "sLOTSMemberId" ? null : (
            <>
                <ActionContainer>
                    <DropdownAction
                        key={index}
                        value={value}
                        id={index}
                        index={index}
                        options={this.state.actionDropdown}
                        align="right"
                        onOptionClick={this.actionClick.bind(this)}
                    />
                </ActionContainer>
            </>
        );
    };
    setFilterParameters = (id) => {
        let detail = this.state.pagination;
        detail.pageNo = 1;
        detail.FilterByStatus = id;
        this.setState({ pagination: { ...detail } }, () => {
            this.getAllSlotProbationTasksList();
        });
    };

    searchByName = (value) => {
        let detail = this.state.pagination;
        detail.searchText = "";
        this.setState({ pagination: { ...detail } });
        if (value.length > 2) {
            detail.pageNo = 1;
            detail.pageSize = 10;
            detail.searchText = value;
            this.setState({ pagination: { ...detail } });
        }
        this.getAllSlotProbationTasksList();
    };

    GetSlotsMemberFiles = (id, type, Filepath) => {

        if (Filepath) {
            let request =
                [id,
                    type,
                    Filepath,
                ];
            this.slotMemberService.GetSlotsMemberFiles(request).then((response) => {
                if (response.data !== null && response.status === 200) {
                    var formattedDate = moment(new Date()).format("DDMMYYYYHHmmss");
                    var filename = "";
                    filename = `${type}${formattedDate}`;
                    const extension = Filepath.split(".").pop();
                    if (extension) {
                        saveAs(new Blob([response.data]), `${filename}.${extension}`);
                    }
                } else {
                    this.swalServices.Error(response.message);
                }
            });
        } else {
            this.swalServices.Error("No data found");
        }
    };

    getAllDropdownsForTaskList = () => {
        this.TaskListServices.getAllDropdownsForTaskList().then((response) => {
            if (response.statusCode === 200 && response.responseItem != null) {
                var status = response.responseItem.responseContent
                    .filter((drp) => drp.dropdownName === "Status")
                    .filter((item) => [2, 4, 12, 21, 24, 28, 29].includes(item.id))
                    .map((item) => {
                        delete item["dropdownName"];
                        return item;
                    });


                var projectType = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "SlotProjectType");
                projectType.map(function (item) { delete item["dropdownName"]; return item; });

                this.setState({ status: status, projectTypelist: projectType });
            }
        });
        this.getAllSlotProbationTasksList();
    }


    handleChange(event) {
        const value = event.target.value;
        const name = event.target.name;
        let detail = this.state.pagination;
        let fulldate = (detail[name] = value === "" ? null : value);
        let date = new Date(fulldate); //1/1/1753 12:00:00 AM and 12/31/9999 11:59:59 PM
        let startLimit = new Date("1/1/1753 12:00:00 AM");
        let endLimit = new Date("12/31/9999 11:59:59 PM");
        detail[name] = value;
        this.setState({ pagination: { ...detail } }, () => {
            if (startLimit < date && date < endLimit) {
                this.getAllSlotProbationTasksList();
            } else if (fulldate === null) {
                this.getAllSlotProbationTasksList();
            }
        });
    }


    RejectSlotsProbation = () => {
        this.setState(prevState => ({ internalComments: { ...prevState.internalComments, isApprovedProbation: 0 } }),
            () => {
                const request = {
                    sLOTSMemberId: this.state.taskDetails?.slotsMemberId,
                    internalComment: this.state.internalComments?.internalComment || "",
                    isApprovedProbation: this.state.internalComments?.isApprovedProbation,
                };

                if (!request.sLOTSMemberId) {
                    this.swalServices.Error("Unable to reject: Invalid Member ID.");
                    return;
                }

                this.swalServices
                    .Confirm(
                        CommonSuccessMessages.Confirm_Reject.replace("{0}", "Slots Probation application"),
                        "",
                        CommonSuccessMessages.Yes_Text,
                        CommonSuccessMessages.No_Text
                    )
                    .then((confirmed) => {
                        if (confirmed) {
                            this.TaskListServices.RejectSlotsProbation(request).then((response) => {
                                if (response.statusCode === 200 && response.responseItem != null) {
                                    this.getAllSlotProbationTasksList();
                                    this.swalServices.Success("Slot Probation rejected successfully");
                                    this.setState({ addeditModalOpen: false });
                                } else {
                                    this.swalServices.Error("Failed to reject slot probation.");
                                }
                            }).catch(() => {
                                this.swalServices.Error("Something went wrong while rejecting the slot probation.");
                            });
                        }
                    });
            }
        );
    };



    searchBySubmissionDate = () => {
        this.getAllSlotProbationTasksList(this.state.pagination);
    }


    AcceptMembershipforSlotsMemberProbation = () => {
        this.setState(
            prevState => ({
                internalComments: {
                    ...prevState.internalComments,
                    isApprovedProbation: 1
                }
            }),
            () => {
                this.swalServices
                    .Confirm(
                        CommonSuccessMessages.Confirm_Accept.replace("{0}", "Slots Probation application"),
                        "",
                        CommonSuccessMessages.Yes_Text,
                        CommonSuccessMessages.No_Text
                    )
                    .then((confirmed) => {
                        if (confirmed) {
                            const request = {
                                sLOTSMemberId: this.state.taskDetails?.slotsMemberId,
                                internalComment: this.state.internalComments?.internalComment || "",
                                isApprovedProbation: this.state.internalComments?.isApprovedProbation,
                            };

                            this.TaskListServices.AcceptMembershipforSlotsMemberProbation(request).then((response) => {
                                if (response.statusCode === 200 && response.responseItem != null) {
                                    this.getAllSlotProbationTasksList();
                                    this.swalServices.Success("Slot Probation approved successfully");
                                    this.setState({ addeditModalOpen: false });
                                } else {
                                    this.swalServices.Error("Failed to approve slot probation.");
                                }
                            }).catch(() => {
                                this.swalServices.Error("Something went wrong while approving the slot probation.");
                            });
                        }
                    });
            }
        );
    };

    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }
        return (
            <>
                <div className="main-body-section">
                    <div className="bg-white px-8 pt-10 pb-12">
                        <div className="grid grid-cols-12 gap-6 w-full items-center">
                            <div className="2xl:col-span-2 lg:col-span-4 col-span-12">
                                <h2 className="input-title mb-3">
                                    {/* Search by Company */}
                                    Search by Status
                                </h2>
                                <div className="col-end-7 col-span-3 grid grid-cols-3 items-center">
                                    <input
                                        id="default"
                                        className="col-span-4 h-[55px] w-full text-[#000000] border-white"
                                        type="text"
                                        placeholder="Search"
                                        onChange={(e) => this.searchByName(e.target.value, 'CompanyName')}
                                    />
                                </div>
                            </div>
                            <div className="2xl:col-span-3 lg:col-span-2 col-span-12">
                                <h2 className="input-title mb-3">
                                    Status
                                    {/* <span className="text-[#c00000]">*</span> */}
                                </h2>

                                <div className="">
                                    <DropdownSelect
                                        drpIdentity={"filterByStatusId"}
                                        optionArray={this.state.status}
                                        setFilterParameters={this.setFilterParameters.bind(this)}
                                        value={this.state.pagination.FilterByStatus}
                                    />
                                </div>
                            </div>
                            <div className="2xl:col-span-1 lg:col-span-1 col-span-12 pt-8 text-center">
                                <div className="border-l-[1px] border-[#000000] h-[48px] inline-block mx-auto"></div>
                            </div>

                            <div className="2xl:col-span-5 lg:col-span-6 col-span-12 pr-2">
                                <h2 className="input-title mb-3">
                                    Date
                                    {/* <span className="text-[#c00000]">*</span> */}
                                </h2>
                                <div className="grid grid-cols-12 gap-6 items-center w-full">
                                    <div className="2xl:col-span-5 lg:col-span-5 col-span-12 w-full">
                                        <input
                                            id="default"
                                            name="dateFrom"
                                            className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                                            type="date"
                                            value={this.state.pagination.dateFrom}
                                            onChange={(e) => this.handleChange(e)}
                                        />
                                    </div>
                                    <div className="2xl:col-span-1 lg:col-span-1 col-span-12 w-full text-center">
                                        <h2 className="text-xl theme-color">To</h2>
                                    </div>
                                    <div className=" 2xl:col-span-5 lg:col-span-5 col-span-12 w-full">
                                        <input
                                            id="default"
                                            name="dateTo"
                                            className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                                            type="date"
                                            value={this.state.pagination.dateTo}
                                            onChange={(e) => this.handleChange(e)}
                                        />
                                    </div>
                                    <div className=" 2xl:col-span-1 lg:col-span-5 col-span-12 w-full slotacccredition-btn-design-set">
                                        <button
                                            className="btn btn-blue text-white font-semibold"
                                            onClick={() => this.searchBySubmissionDate()}
                                        >
                                            <span className="text-xl text-white font-semibold tracking-normal">
                                                Search
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="grid grid-cols-6 gap-4 pt-10 px-8">
                        <h2 className="col-start-1 col-end-3 text-3xl font-bold text-[#000000]">
                            {`Total:${this.state.totalResultes}`}
                        </h2>
                        <div className="col-end-7 col-span-3 grid grid-cols-3 items-center">
                            {/* <caption className="text-[#000000] text-xl text-right pr-5">Search by Company </caption>
                  <input
                    id="default"
                    className="col-span-2 text-lg font-bold h-[55px] w-full text-[#000000] border-white"
                    type="text"
                    onChange={(e) => this.searchByName(e.target.value)}
                  /> */}
                        </div>
                    </div>
                    <main className="pb-10">
                        <div className="w-full mx-auto">
                            <div className="relative">
                                <div>
                                    <div className=" mt-6">
                                        <Table
                                            columns={[
                                                {
                                                    name: "RegistrationDate",
                                                    title: "Registration Date",
                                                },
                                                { name: "FullName", title: "Name" },
                                                { name: "Email", title: "Email Address" },
                                                { name: "CompanyName", title: "Company Name" },
                                                { name: "UENNumber", title: "Company UEN" },

                                                { name: "StatusName", title: "Status" },
                                                { name: "sLOTSMemberId", title: "Action" },
                                            ]}
                                            pagination={this.state.pagination}
                                            rows={this.state.taskList}
                                            sortingColumns={["source", "registrationDate"]}
                                            isLoading={this.state.isLoading}
                                            totalResultes={this.state.totalResultes}
                                            totalCount={this.state.totalResultes}
                                            setPagination={this.setPagination.bind(this)}
                                            customScope={[
                                                {
                                                    column: "sLOTSMemberId",
                                                    renderTableData: this.actions.bind(this),
                                                },
                                            ]}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
                <div className="member-task-process">
                    <SlotProbationTaskListProcess
                        setAddeditModalOpen={this.state.setAddeditModalOpen}
                        setModalOpen={() => this.setState({ setAddeditModalOpen: false })}
                        onClose={(e) => {
                            e.stopPropagation();
                            this.setState({ setAddeditModalOpen: false });
                        }}
                        closeModalOnBack={() => {
                            this.setState({ setAddeditModalOpen: false });
                        }}
                        modalOpen={this.state.addEditModalOpen}
                        handleChange={this.handleChangeInPopup.bind(this)}
                        taskDetails={this.state.taskDetails}
                        // handleApprove={this.AcceptMembershipforSlotsMemberProbation}
                        slotsMemberId={this.state.taskDetails.slotsMemberId}
                        ongoingProjectTrackRecordsDetailsList={this.state.ongoingProjectTrackRecordsDetailsList}
                        completedProjectTrackRecordsDetailsList={this.state.completedProjectTrackRecordsDetailsList}
                        RejectSlotsProbation={this.RejectSlotsProbation.bind(this)}
                        handleApprove={this.AcceptMembershipforSlotsMemberProbation.bind(this)}

                        isOngoing={this.state.IsOngoing}
                        isCompleted={this.state.IsCompleted}
                        projectTypelist={this.state.projectTypelist}
                        GetSlotsMemberFiles={this.GetSlotsMemberFiles.bind(this)}
                        internalComments={this.state.internalComments}
                        handleChangeForComment={this.handleChangeForComment.bind(this)}

                    />


                </div>
            </>
        );
    }
}